<sb-dialog-header>
  <h3 sb-dialog-title>{{ 'Continue with Free?' | translate }}</h3>
</sb-dialog-header>

<sb-dialog-content>
  <div class="flex flex-col gap-lg">
    <p class="reset-p text-subtle">
      {{
        'To switch, your account will be adjusted to fit the Free plan. This means removing some teams and departments, and deactivating some employees first.'
          | translate
      }}
    </p>

    <sb-dialog-block [header]="'You\'ll have to say goodbye to' | translate">
      <ul class="reset-ul flex flex-col gap-sm">
        @for (quota of data.quotaReached; track quota.type) {
          @let overBy = quota.usage - quota.limit;
          <li class="flex items-center gap-sm">
            <sb-icon class="shrink-0 text-support" name="times-circle" />
            @switch (quota.type) {
              @case (quotaType.SEATS) {
                @if (overBy === 1) {
                  {{ '1 employee' | translate }}
                } @else {
                  {{ '[count] employees' | translate: { count: overBy } }}
                }
              }
              @case (quotaType.TEAMS) {
                @if (overBy === 1) {
                  {{ '1 team' | translate }}
                } @else {
                  {{ '[count] teams' | translate: { count: overBy } }}
                }
              }
              @case (quotaType.DEPARTMENTS) {
                @if (overBy === 1) {
                  {{ '1 department' | translate }}
                } @else {
                  {{ '[count] departments' | translate: { count: overBy } }}
                }
              }
            }
          </li>
        }
      </ul>
    </sb-dialog-block>
  </div>
</sb-dialog-content>

<sb-dialog-footer>
  <div class="flex w-full flex-col gap-sm">
    <button sb-button color="primary" class="w-full" [sb-dialog-close]="'switch-to-free'">
      {{ 'Yes! Continue with Free' | translate }}
    </button>
    <button sb-button color="secondary" class="w-full" [sb-dialog-close]="'keep-plan'">
      {{ 'No, stay with my current plan' | translate }}
    </button>
  </div>
</sb-dialog-footer>
